import { render } from "./LocaleSwitcher.vue?vue&type=template&id=4f549c7a"
import script from "./LocaleSwitcher.vue?vue&type=script&lang=js"
export * from "./LocaleSwitcher.vue?vue&type=script&lang=js"

import exportComponent from "/Users/celalkasli/Documents/tink/tink-cancellation-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__